<div class="fs-11 fw-2 text-neutral-dark">{{upperCase ? (text | uppercase) : (text | titlecase) || 'N/A' }}</div>

